import { get } from "./helpers";

export const fetchSchedules = async (query) => {
  const { lowRange, highRange } = query;

  //console.log(query);
  const url = `/api/agency/appt?lowRange=${lowRange}&highRange=${highRange}`;

  const result = await get(url);
  return result.data;
};
